export let StatusCode = {
  '0': 'lang.scenerio.status.invalid',
  '1': 'lang.scenerio.status.submitted',
  '2': 'lang.scenerio.status.in_progress',
  '3': 'lang.scenerio.status.completed',
  '4': 'lang.scenerio.status.failed',
  '5': 'lang.scenerio.status.in_planning',
  '6': 'lang.scenerio.status.in_review',
  '7': 'lang.scenerio.status.approved',
  '8': 'lang.scenerio.status.rejected',
  '9': 'lang.scenerio.status.planned',
  '10': 'lang.scenerio.status.in_market',
  '11': 'lang.scenerio.status.past'
}

export let StatusColor = {
  '1': '#FDCB4E',
  '2': '#FDCB4E',
  '3': '#32AC70',
  '4': '#FF0000',
  '5': '#FDCB4E',
  '6': '#B0DDF5',
  '7': '#32AC70',
  '8': '#FF0000',
  '9': '#32AC70',
  '10': '#FDCB4E',
  '11': '#22232233'
}

export let componentNavigationLabel = {
  '1001': 'lang.navigation.home',
  '1002': 'lang.navigation.final_recommendation',
  '1003': 'lang.navigation.price_performance',
  '1004': 'lang.navigation.price_recommendation',
  '1005': 'lang.navigation.price_optimiser',
  '1006': 'lang.navigation.scenerio_planner',
  '1007': 'lang.navigation.competitor_pricing',
  '1008': 'lang.navigation.notification',
  '1009': 'lang.navigation.modeling',
  '2003':'lang.navigation.scenario_list',
  '2004':'lang.navigation.scenario_comparison',
  '2001':'lang.navigation.recommendation_list',
  '2002':'lang.navigation.import_pricing_rules',
  '2005':'lang.navigation.recommendation_list',
  '2006': 'lang.navigation.elastic_band'
}

export let scenerioType = {
  'all': '',
  'scenerio': 'sp',
  'optimiser': 'opt'
}

export let RecommenderScenariosType = {
  'all': '',
  'approved': 'Approved',
  'in_market': 'In Market',
  'planned': 'Planned',
  'in_review': 'In Review'
}

export let statusCodeValues = {
  'invalid': '0',
  'submitted': '1',
  'in_progress': '2',
  'completed': '3',
  'failed': '4',
  'in_planning': '5',
  'in_review': '6',
  'approved': '7',
  'rejected': '8',
  'planned': '9',
  'in_market': '10',
  'past': '11'
}

export let notificationNavigation ={
  '7' : '/final-recommendation',
  '6': 'final-recommendation/in-review',
  '8': '/scenario/scenario-planner'
}

export enum sessionStorageKeys {
  configuration = 'configuration',
}

export enum localStorageKeys {
  navigation_code = 'navigation_code',
  features_available ='features_available',
  user_name = 'user_name',
  role_id ='role_id',
  api_keys = 'api_keys',
  market ='market',
  menu= 'menu'
}

export enum indexedDBKeys {
  configuration = 'configuration',
}

export let priceSensitivity = {
  1: 'lang.scenerio.price_sensitivity.low',
  2: 'lang.scenerio.price_sensitivity.medium',
  3: 'lang.scenerio.price_sensitivity.high',
  0: 'lang.scenerio.price_sensitivity.not_modelled'
}

export let priceSensitivityTextColor = {
  1: '#32AC70',
  2: '#FDCB4E',
  3: '#FF0000',
}

export let dahsboardIcon = {
  '1001': './../../assets/images/dashboard/price-recommendation.svg',
  '1002': "./../../assets/images/dashboard/final-recommendation.svg",
  '1003': "./../../assets/images/dashboard/price-performance.svg",
  '1004': "./../../assets/images/dashboard/price-recommendation.svg",
  '1005': "./../../assets/images/dashboard/price-recommendation.svg",
  '1006': "./../../assets/images/dashboard/scenario-planner.svg",
  '1007': "./../../assets/images/dashboard/competitor-pricing.svg",
  '1008': "./../../assets/images/dashboard/price-recommendation.svg",
  'UK':'./../../assets/images/dashboard/united-kingdom.png',
  'IN':'./../../assets/images/dashboard/india.png'
}

export let chart_types = {
  line: 'line',
  bar: 'bar',
  stacked_bar: 'stacked_bar',
  waterfall: 'waterfall',
  bar_line: 'bar_line',
  stacked_bar_line: 'stacked_bar_line',
  est_vs_act_bar : 'est_vs_act_bar',
}

export let price_performance_charts = {
  est_v_act: "estimated_v_actuals",
  margin_trends: "margin_trends",
  price_trends: "price_trends",
  metric_trends: "metric_trends",
  price_band_analysis: "price_band_analysis",
}

export let recalculation_type ={
  price_change:1,
  current_price:2,
  recommendation_price:3,
  upload_item_calculation:4,
  price_hierarchy : 5
}

export let function_calculation_type ={
  calculate_save:  "calculate_save",
  recalculate: "recalculate"
}

export let newPriceRecommenderObjective = {
  maximize_revenue:"Maximize Revenue",
  maximize_gross_margin:"Maximize Gross Margin",
  maximize_perc_gross_margin:"Maximize Gross Margin %"
}

export let scenario_error :any ={
  500:{
    "Please_check_for_invalidzero_price_entries_for_the_products_that_require_a_price": "lang.scenerio.save_error"
  }
}
export let recalculate_errors :any={
  406: {
    "request_id": "lang.scenerio.error_messages.request_id",
    "scenario_id":"lang.scenerio.error_messages.scenario_id",
    "re_calculation_type": "lang.scenerio.error_messages.re_calculation_type",
    "function_calculation_type":"lang.scenerio.error_messages.function_calculation_type",
    "parent_optimizer_id":"lang.scenerio.error_messages.parent_optimizer_id",
    "price_changed_items":"lang.scenerio.error_messages.price_changed_items",
  }
}
export let uploadError : any ={
  "excel_validation_failed": "lang.scenerio.upload_validation_error"
}
export let priceRecommenderErrors : any = {
  406:{
    "download_constraint_rule": "lang.price_recommendation.error_messages.ErrorWhileDownloadingTemplate",
  }
}

export let newPriceRecommenderErrors : any = {
    406:{
      "File_Type_Error_Allowed_file_type_xlsx": "lang.new_price_recommender.error_messages.FileTypeErrorAllowedFileTypeXlsx",
    },
    500:{
      "Error_while_writing_file_to_storage":"lang.new_price_recommender.error_messages.ErrorWhileWritingFileToStorage"
    },
    400:{
      "Parameters name, description, pricing_cycle_date, request id should be provided.":"lang.new_price_recommender.error_messages.ErrorWhileEmptyDataSend",
      "max_opt_run":"lang.new_price_recommender.maximum_optimiser_error",
      "max_opt_run_warn":"lang.new_price_recommender.maximum_optimiser_warning"
    }
}

export let price_performance_errors:any ={
  "est_vs_act_date_error": "lang.price_performance.error.est_vs_act_6_week_error",
  "no_data": "lang.price_performance.error.no_data",
  "invalid_combination": "lang.price_performance.error.invalid_combination"
}

export let http_status_codes: any = {
  // using 404 since exception service uses success for status code 204
  NO_CONTENT: 404,
}

export let estimated_panel_duration: any = {
  'weekly': 'Per Week',
  '12_weeks': 'Next 12 Weeks',
  '52_weeks': 'Next 1 Year',
  'yte': 'Year to Go',
}
export let estimated_panel_duration_order: any = {
  'weekly': 1,
  '12_weeks': 2,
  '52_weeks': 4,
  'yte': 3,
}

export let navigation_codes:any ={
  'price-recommender':1004,
  'scenario-planner':1006,
  'final-recommendation':1002 ,
  'price-performance':1003 ,
  'competitor':1007
}

export let action_items:any ={
  'create_scenario': 1,
  'submit_for_approval':2,
  'approver': 3,
  'intiate_recommendation': 4,
  'scenario_past': 5,
  'scenario_market': 6,
  'delete_scenario': 7,
  'dynamic_price_band': 8,
}

export let role_name:any = {
  1:'Approver',
  2:'Analyst',
  3:'Support',
  4:'Admin'
}

export let category_name :any ={
  food: "Food",
  beverage: "Beverages",
  and: "and"
}

export let currency_symbol_enum :any ={
  '€': '£',
  '₹': '₹'
}

export let translate_enum:any ={
  UK: 'uk',
  IN: 'in'
}


export let country_name:any ={
  UK: "UK",
  IN: "India"
}

export let currency_symbol_est_act_enum :any =['Transactions','Transaction', 'Units']